import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'
const path = '/api/widget-settings/[slug]'

export const getPageUrl = toPathFactory(path, getPublicUrl)
